
import React from 'react';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface TeacherStatusToggleProps {
  includeInactive: boolean;
  onToggle: (includeInactive: boolean) => void;
}

export const TeacherStatusToggle: React.FC<TeacherStatusToggleProps> = ({
  includeInactive,
  onToggle,
}) => {
  return (
    <div className="flex items-center space-x-2">
      <Switch
        id="include-inactive"
        checked={includeInactive}
        onCheckedChange={onToggle}
      />
      <Label htmlFor="include-inactive">
        แสดงครูทั้งหมด (รวมครูที่ไม่ใช้งาน)
      </Label>
    </div>
  );
};
